import { AxiosError } from "axios";
import AuthClient from "../AuthClient";

export interface ApiResponse<T> {
    statusCode: number;
    errorMessage: string;
    data?: T;
}

export function handleAxiosError<T>(error: AxiosError): ApiResponse<T> {
    const axiosError = error as AxiosError;
    const authClient = new AuthClient();
    if (axiosError.response) {
        const { status, data } = axiosError.response;

        switch (status) {
            case 400:
                console.error("Bad Request Error (400)", data);
                break;
            case 401:
                void authClient.logout().then(() => {
                    window.location.href = "/rapp";
                });
                console.error("Unauthorized Error (401)", data);
                break;
            case 404:
                console.error("Not Found URL (404)", data);
                break;
            case 500:
                console.error("Internal server Error (500)", data);
                break;
            default:
                console.error("Unhandled Error", data);
                break;
        }

        return {
            statusCode: status,
            errorMessage: axiosError.message as string,
            data: undefined,
        };
    }

    console.error("Unhandled Axios Error", axiosError);
    return {
        statusCode: 500,
        errorMessage: axiosError.message as string,
        data: undefined,
    };
}
